import { Row, SortingFn } from '@tanstack/react-table';

import { CatalogItem } from '../types';

export const PERIOD_TYPE_SORTING_ORDER: Record<string, number> = {
  Prompt: 1,
  Hour: 2,
  '12Hour': 3,
  HalfDay: 4,
  Day: 5,
  Week: 6,
  HalfMonth: 7,
  Cycle: 8,
  Month: 9,
  Quarter: 10,
  Season: 11,
  HalfYear: 12,
  Year: 13
};

export const FREQUENCY_SORTING_ORDER: Record<string, number> = {
  Daily: 1,
  Weekly: 2,
  Monthly: 3,
  Quarterly: 4,
  Annual: 5
};
export const sortAsNumber: SortingFn<CatalogItem> = (
  rowA: Row<CatalogItem>,
  rowB: Row<CatalogItem>,
  columnId: string
) => {
  return Number(rowA.getValue(columnId)) - Number(rowB.getValue(columnId));
};

export const isBeforeWithOrder = (valueA: any, valueB: any, order: Record<string, number>) => {
  const keyA = String(valueA);
  const keyB = String(valueB);

  const hasKeyA = keyA in order;
  const hasKeyB = keyB in order;

  if (hasKeyA && hasKeyB) {
    return order[keyA] - order[keyB];
  }

  if (hasKeyA) return -1;
  if (hasKeyB) return 1;

  return keyA.localeCompare(keyB);
};

export const sortByOrder = (
  rowA: Row<CatalogItem>,
  rowB: Row<CatalogItem>,
  columnId: string,
  order: Record<string, number>
) => {
  const valueA = rowA.getValue(columnId);
  const valueB = rowB.getValue(columnId);

  return isBeforeWithOrder(valueA, valueB, order);
};
export const sortAsPeriodType: SortingFn<CatalogItem> = (
  rowA: Row<CatalogItem>,
  rowB: Row<CatalogItem>,
  columnId: string
) => {
  return sortByOrder(rowA, rowB, columnId, PERIOD_TYPE_SORTING_ORDER);
};

export const sortAsFrequency: SortingFn<CatalogItem> = (
  rowA: Row<CatalogItem>,
  rowB: Row<CatalogItem>,
  columnId: string
) => {
  return sortByOrder(rowA, rowB, columnId, FREQUENCY_SORTING_ORDER);
};
